module.exports = __webpack_public_path__ + "static/southwest_express-e578b54d8c36a403f7bed6e3e3a22997.jpg";